import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import moment from "moment";
import {
  ChevronRightIcon,
  CalendarDaysIcon,
  ChevronLeftIcon,
} from "@heroicons/react/24/outline";

import { theme } from "../../utils/theme";
import Calendar from "@toast-ui/react-calendar";
import "tui-calendar/dist/tui-calendar.css";
import "@toast-ui/calendar/dist/toastui-calendar.min.css";
import "./calendar-styles.css";

import { useNCallContext } from "../../context/ncall-context";
import Loader from "../loader";
import {
  currentTime,
  makeStamp,
  validDate,
  validTime,
} from "../../utils/timestamp";
import ScheduleDetailModal from "../modal/scheduleDetailModal";
import {
  showErrorToast,
  showSuccessToast,
  showWarningToast,
} from "../../utils/toast";
import { API } from "../../service/api";
import Modal from "../modal/modal";
import {
  availableShifts,
  selectedEmployee,
  selectedShift,
  shiftFilter,
} from "../../utils/helperSchedule";

// modal config
const config = {
  title: "",
  handler: null,
};

const NCallSchedular = () => {
  //console.log("refreshing calendar");

  const {
    state,
    calendars,
    schedules,
    getEmployees,
    getDepartments,
    getSchedules,
    postSchedules,
    getShifts,
    setOpenModal,
    openModal,
    openDetailModal,
    setOpenDetailModal,
    inprogressField,
    setInprogressField,
  } = useNCallContext();

  // used for showing the details
  const [schedule, setSchedule] = useState({});
  const [employee, setEmployee] = useState("");
  const [employee1, setEmployee1] = useState("");
  const [department, setDepartment] = useState("");
  const [note, setNote] = useState("");
  const [shift, setShift] = useState("");
  const [start, setStart] = useState(moment().format("YYYY-MM-DD"));
  let updateId = "";

  let eventStatus = "";
  const [filteredShifts, setFilteredShifts] = useState(state.shifts);

  const calendarRef = useRef(null);

  const [selectedCalendar, setSelectedCalendar] = useState("All");
  const [filteredschedules, setfilteredschedules] = useState();

  const [selectedDateRangeText, setSelectedDateRangeText] = useState("");

  const { employees, departments, shifts } = state;

  const options = useMemo(() => {
    console.log("memoized");

    return employees.map((employee) => ({
      label: employee.hasOwnProperty("Alias")
        ? employee.Alias
        : `${employee.Firstname} ${employee.Lastname}`,
      value: employee.hasOwnProperty("Alias")
        ? employee.Alias
        : `${employee.Firstname} ${employee.Lastname}`,
    }));
  }, [employees]);

  // get Emp from the options

  const getEmpFromOptions = (name) => {
    if (!options) return;
    return options.find((op) => op.value === name);
  };

  // schedualr refresh
  const [refresh, setRefresh] = useState(false);
  const getCalInstance = useCallback(
    () => calendarRef.current?.getInstance?.(),
    []
  );

  useEffect(() => {
    if (schedules.length === 0) {
      getSchedules();
    }

    if (state.employees.length === 0) {
      getEmployees();
    }

    if (state.shifts.length === 0) {
      getShifts();
    }
    if (state.departments.length === 0) {
      getDepartments();
    }
  }, []);

  useEffect(() => {
    setfilteredschedules([]);
    getSchedules();
  }, [refresh]);

  const updateRenderRangeText = useCallback(() => {
    const calInstance = getCalInstance();
    if (!calInstance) {
      setSelectedDateRangeText("");
      return;
    }

    const calDate = calInstance.getDate();

    let year = calDate.getFullYear();
    let month = calDate.getMonth() + 1;
    let dateRangeText = "";

    dateRangeText = moment(`${year}-${month}`).format("MMMM YYYY");

    setSelectedDateRangeText(dateRangeText);
  }, []);

  useEffect(() => {
    updateRenderRangeText();
  }, []);

  //  return  the calendar
  const getSecletedCalendar = (name) => {
    const calendar = calendars.find((item) => item.name === name);
    return calendar;
  };

  // return the selected shift

  const getSelectedShift = (id) => {
    // const shift = shifts.find((item) => item.id === id);
    // return shift;

    return selectedShift(shifts, id);
  };

  //return the selected employee
  const getSelectedEmployee = (employeeName) => {
    const { employees } = state;

    if (employees.length === 0 || employeeName === "") return;

    // const emp = employees.find(
    //   // Don't remove this concatinated space it matters
    //   (employee) =>
    //     employee.Firstname + " " + employee.Lastname === employeeName
    // );

    return selectedEmployee(employees, employeeName);
  };

  // filtered Schedules

  const _filteredShcedules = () => {
    let _filteredschedules = [];
    if (selectedCalendar !== "All") {
      let calendar = getSecletedCalendar(selectedCalendar);
      _filteredschedules = schedules.filter(
        (schedule) => schedule.calendarId === calendar.id
      );
      setfilteredschedules(_filteredschedules);
    } else {
      setfilteredschedules(schedules);
    }
  };

  useEffect(() => {
    _filteredShcedules();
  }, [selectedCalendar]);

  // Refresh useEffect()
  useEffect(() => {
    _filteredShcedules();
    updateRenderRangeText();
  }, [schedules]);

  const onClickNavi = (ev) => {
    if (ev.target.tagName === "BUTTON") {
      const button = ev.target;
      const actionName = (
        button.getAttribute("data-action") ?? "month"
      ).replace("move-", "");

      getCalInstance()[actionName]();
      updateRenderRangeText();
    }
  };

  //! On click of an event it checks if the date is
  //! valid means its not past yet then it will display modals diffretntly

  const onClickEvent = (res) => {
    let _schedule = state.schedules.find((item) => item.id === res.event.id);
    eventStatus = "";
    if (
      currentTime(
        _schedule.date,
        _schedule.shifts.startTime,
        _schedule.shifts.endTime
      )
    ) {
      eventStatus = "in-progress";
      setForm(_schedule.date, _schedule);
    } else if (
      validTime(
        _schedule.date,
        _schedule.shifts.startTime,
        _schedule.shifts.endTime
      )
    ) {
      eventStatus = "pending";
      setForm(_schedule.date, _schedule);
    } else {
      eventStatus = "passed";
      setSchedule({ ..._schedule, scheduleStatus: eventStatus });
      setOpenDetailModal(true);
    }
  };

  const setForm = (date, schedule = null) => {
    let newDate = moment(date).format("YYYY-MM-DD");
    const { shifts } = state;

    const _filteredShifts = availableShifts(shifts, newDate);

    // shifts.filter((shift) =>
    //   validTime(date, shift.startTime, shift.endTime)
    // );

    setFilteredShifts(_filteredShifts);

    if (_filteredShifts.length === 0) {
      showWarningToast(
        "There is no shift available today to make schedule for."
      );
      return;
    }
    let schedualEmpolyee = options[0];
    if (schedule) {
      schedualEmpolyee = getEmpFromOptions(schedule.employeeName);
    }

    setStart(newDate);

    if (schedule !== null && eventStatus === "pending") {
      updateId = schedule.id;

      config.title = "Update Schedule";
      config.handler = handleUpdateSchedule;
      config.eventStatus = eventStatus;

      setDepartment(schedule.Department.department);
      // find the employee in options and set it

      setEmployee(schedualEmpolyee);

      setNote(schedule.shortNote);
      setShift(schedule.shift_id);
    } else if (schedule !== null && eventStatus === "in-progress") {
      updateId = schedule.id;

      config.title = "Update In-progress Schedule";
      config.handler = handleInprogressUpdateSchedule;
      config.eventStatus = eventStatus;

      setDepartment(schedule.Department.department);
      setEmployee(schedualEmpolyee);
      setNote(schedule.shortNote);
      setShift(schedule.shift_id);
    } else {
      config.title = "Create New Schedule";
      config.handler = handleCreateSchedule;
      config.eventStatus = eventStatus;

      setDepartment(departments[0]?.department);
      setEmployee(schedualEmpolyee);
      setStart(newDate);
      setNote(departments[0]?.department);
      setShift(_filteredShifts[0].id);
    }
    if (eventStatus === "in-progress") {
      setInprogressField(true);
    }
    setOpenModal(true);
  };

  // reset Form
  const resetForm = () => {
    setNote("");
    setEmployee("");
    setDepartment("");
    setShift("");
    setStart("");
  };

  const handleShiftChange = (e) => {
    setShift(e.target.value);
  };

  const handleInprogressUpdateSchedule = async (e) => {
    const submitter = e.nativeEvent.submitter.name;
    setOpenModal(false);
    setInprogressField(false);

    if (submitter === "save") {
      if (updateId === "") {
        return;
      }
      const _emp = e.target.elements["employee"].value;

      let emp = getSelectedEmployee(_emp);

      let paylaod = {
        employeeId: emp.ID,
        employeeName: _emp,
      };

      try {
        const res = await API.patchInProgressSchedule(updateId, paylaod);
        if (res.error) {
          showErrorToast(res.error.message);
        } else {
          showSuccessToast(res.message);
        }
      } catch (error) {
        showErrorToast(error.message);
      }
    }
    if (submitter === "delete") {
      if (updateId === "") {
        return;
      }
      try {
        const res = await API.deleteInProgressSchedule(updateId);
        if (res.error) {
          showErrorToast(res.message);
        } else {
          showSuccessToast(res.message);
        }
      } catch (error) {
        showErrorToast(error);
      }
    }
    setRefresh(!refresh);
    updateId = "";
  };

  const handleUpdateSchedule = async (e) => {
    e.preventDefault();
    setOpenModal(false);

    if (updateId === "") {
      return;
    }

    const _emp = e.target.elements["employee"].value;
    // const _emp = employee.value;
    const _dep = e.target.elements["department"].value;
    const _shift = e.target.elements["shift"].value;
    const _note = e.target.elements["note"].value;
    const _date = e.target.elements["start"].value;

    let dep = getSecletedCalendar(_dep);

    let shft = getSelectedShift(_shift);
    // employee name comes from state
    let emp = getSelectedEmployee(_emp);
    // let emp = getSelectedEmployee(employee.value);

    let timestamp = {};
    if (shft) {
      timestamp = makeStamp(_date, shft.startTime, shft.endTime);
    }

    let paylaod = {
      department_id: dep.id,
      contactId: "2",
      shortNote: _note,
      shift_id: _shift, // id
      startTime: timestamp?.startTime,
      endTime: timestamp?.endTime,
      employeeId: emp.ID,
      employeeName: _emp,
      date: _date,
    };

    try {
      const res = await API.putSchedule(updateId, paylaod);
      if (res.error) {
        showErrorToast(res.error.message);
      } else {
        showSuccessToast(res.message);
      }
    } catch (error) {
      showErrorToast(error.message);
    } finally {
      resetForm();
      setRefresh(!refresh);
      updateId = "";
    }
  };

  const handleCreateSchedule = async (e) => {
    e.preventDefault();
    setOpenModal(false);

    const _emp = e.target.elements["employee"].value;
    // const _emp = employee.value;
    const _dep = e.target.elements["department"].value;
    const _shift = e.target.elements["shift"].value;
    const _note = e.target.elements["note"].value;
    const _date = e.target.elements["start"].value;

    getCalInstance().clearGridSelections();

    let dep = getSecletedCalendar(_dep);

    let shft = getSelectedShift(_shift);

    let emp = getSelectedEmployee(_emp);
    // let emp = getSelectedEmployee(employee.value);

    let timestamp = {};
    if (shft) {
      timestamp = makeStamp(_date, shft.startTime, shft.endTime);
    }
    let paylaod = {
      department_id: dep.id,
      contactId: "2",
      shortNote: _note,
      shift_id: _shift, // id
      startTime: timestamp?.startTime,
      endTime: timestamp?.endTime,
      employeeId: emp.ID,
      employeeName: _emp,
      date: _date,
    };

    try {
      const res = await postSchedules(paylaod);
    } catch (error) {
      showErrorToast(error.message);
    } finally {
      resetForm();
      setRefresh(!refresh);
    }
  };

  // const shiftsFilter = (date) => {
  //   const { shifts } = state;
  //   // const _filteredShifts = shifts.filter((shift) =>
  //   //   validTime(date, shift.startTime, shift.endTime)
  //   // );

  //   if (shifts.length === 0) return;

  //   const _filteredShifts = shiftFilter(shifts, date);

  //   if (_filteredShifts.length === 0) {
  //     showWarningToast(
  //       "There is no shift available today to make schedule for."
  //     );
  //     return;
  //   } else setFilteredShifts(_filteredShifts);
  // };

  const handleSelectDateTime = (e) => {
    const { employees, departments, shifts } = state;

    if (validDate(e.start)) {
      if (departments.length === 0) {
        showWarningToast("You dont have any departments to make schedule for.");
        getCalInstance().clearGridSelections();
        return;
      }

      if (employees.length === 0) {
        showWarningToast("You dont have any employees to make schedule for.");
        getCalInstance().clearGridSelections();
        return;
      }

      if (shifts.length === 0) {
        showWarningToast("You dont have any shifts to make schedule for.");
        getCalInstance().clearGridSelections();
        return;
      }
      setForm(e.start);
    } else {
      showWarningToast("You cannot make a schedule for past day!");
    }
    getCalInstance().clearGridSelections();
  };

  const onBeforeDeleteEvent = (res) => {
    const { id, calendarId } = res;

    getCalInstance().deleteEvent(id, calendarId);
  };

  const onBeforeUpdateEvent = (updateData) => {
    const targetEvent = updateData.event;
    const changes = { ...updateData.changes };

    getCalInstance().updateEvent(
      targetEvent.id,
      targetEvent.calendarId,
      changes
    );
  };

  const allDayScheduleTemplate = {
    allday(schedule) {
      return `<span>${schedule.title}<span style="font-size: 9px;  padding-left:2px;">${schedule.raw}</span></span>`;
    },
  };

  // const options = state.employees.map((employee) => ({
  //   label: employee.hasOwnProperty("Alias")
  //     ? employee.Alias
  //     : `${employee.Firstname} ${employee.Lastname}`,
  //   value: employee.hasOwnProperty("Alias")
  //     ? employee.Alias
  //     : `${employee.Firstname} ${employee.Lastname}`,
  //   // employee.id,
  // }));

  if (calendars.length === 0 && schedules.length === 0) return <Loader />;

  return (
    <>
      {openModal ? (
        <Modal config={config}>
          <div className="space-y-6 sm:space-y-5">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="employee"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Employee
              </label>

              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <Select
                  name="employee"
                  // value={employee}
                  isSearchable={true}
                  onChange={(option) => {
                    setEmployee(option);
                  }}
                  value={employee}
                  options={options}
                  className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                />
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="department"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Department
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <select
                  required
                  disabled={inprogressField}
                  value={department}
                  onChange={(e) => {
                    setDepartment(e.target.value);
                    setNote(e.target.value);
                  }}
                  name="department"
                  id="department"
                  className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                >
                  {state?.departments.map((option, index) => (
                    <option
                      value={option.department}
                      key={option.id + "dept" + index}
                    >
                      {option.department}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="shift"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Shift
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <select
                  required
                  disabled={inprogressField}
                  value={shift}
                  onChange={handleShiftChange}
                  id="shift"
                  name="shift"
                  className="block uppercase w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                >
                  {filteredShifts.length === 0 ? (
                    <option
                      key={`no-shift-avaiable`}
                      value="No Shift Available"
                      disabled
                    >
                      No Shift Available
                    </option>
                  ) : (
                    filteredShifts?.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.startTime + "-" + option.endTime}
                      </option>
                    ))
                  )}
                </select>
              </div>
            </div>

            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="start"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Date
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <input
                  disabled
                  min={moment().format("YYYY-MM-DD")}
                  required
                  value={start}
                  onChange={(e) => {
                    setStart(moment(e.target.value).format("YYYY-MM-DD"));
                    // shiftsFilter(moment(e.target.value).format("YYYY-MM-DD"));
                  }}
                  name="start"
                  id="start"
                  type="date"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Select date"
                />
              </div>
            </div>
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
              <label
                htmlFor="note"
                className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
              >
                Job Title
              </label>
              <div className="mt-1 sm:col-span-2 sm:mt-0">
                <textarea
                  required
                  disabled={inprogressField}
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                  type="text"
                  name="note"
                  id="note"
                  className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
                />
              </div>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}
      {/*detail modal for past schedules */}
      {openDetailModal ? <ScheduleDetailModal schedule={schedule} /> : ""}
      <div className="flex flex-row  gap-2 justify-between items-center py-3">
        <div className="flex items-center gap-2">
          <span className=" text-sm font-medium">Department</span>
          <div className="flex items-center ">
            {calendars ? (
              <select
                id="calendars-dep"
                onChange={(e) => setSelectedCalendar(e.target.value)}
                value={selectedCalendar}
                className="block appearance-none  text-sm w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
              >
                {calendars.map((option, index) => (
                  <option value={option.name} key={index} className="text-sm">
                    {option.name}
                  </option>
                ))}
              </select>
            ) : (
              <span>loading</span>
            )}
          </div>
        </div>

        {/* Legends */}
        <div className="flex flex-row flex-wrap justify-center items-center gap-2 px-7">
          {calendars?.map((item) => (
            <div
              key={item.id}
              className="flex flex-row justify-between items-center gap-1 "
            >
              {item.id !== 0 ? (
                <>
                  <div
                    style={{ backgroundColor: item.backgroundColor }}
                    className="h-2 w-2"
                  ></div>
                  <span className="text-xs">{item.name}</span>
                </>
              ) : (
                ""
              )}
            </div>
          ))}
        </div>

        <div className="flex flex-col justify-end">
          <span className="flex-row flex gap-2 items-center">
            <span className="text-base font-medium mr-4">
              {selectedDateRangeText}
            </span>
            <div className="flex flex-row items-center gap-2">
              <button
                type="button"
                className="p-2 grid place-items-center items-center rounded-full border border-transparent bg-indigo-600  text-white shadow-sm hover:bg-indigo-700 "
                data-action="move-today"
                onClick={onClickNavi}
              >
                <CalendarDaysIcon
                  className="h-4 w-4 pointer-events-none"
                  aria-hidden="true"
                />
              </button>
              <button
                type="button"
                className="p-2 grid place-items-center items-center rounded-full border border-transparent bg-indigo-600  text-white shadow-sm hover:bg-indigo-700 "
                data-action="move-prev"
                onClick={onClickNavi}
              >
                <ChevronLeftIcon
                  className="h-4 w-4 pointer-events-none"
                  aria-hidden="true"
                />
              </button>
              <button
                type="button"
                className="p-2 grid place-items-center items-center rounded-full border border-transparent bg-indigo-600  text-white shadow-sm hover:bg-indigo-700 "
                data-action="move-next"
                onClick={onClickNavi}
              >
                <ChevronRightIcon
                  className="h-4 w-4 pointer-events-none"
                  aria-hidden="true"
                />
              </button>
            </div>
          </span>
        </div>
      </div>

      <Calendar
        height="900px"
        calendars={calendars}
        month={{
          startDayOfWeek: 7,
        }}
        template={allDayScheduleTemplate}
        events={filteredschedules || []}
        theme={theme}
        usageStatistics={false}
        useDetailPopup={false}
        useFormPopup={false}
        view="month"
        dragable={false}
        ref={calendarRef}
        onSelectDateTime={handleSelectDateTime}
        onBeforeDeleteEvent={onBeforeDeleteEvent}
        onClickEvent={onClickEvent}
        onBeforeUpdateEvent={onBeforeUpdateEvent}
      />
    </>
  );
};
export default NCallSchedular;
